import {
  Box,
  Stack,
  Step,
  StepConnector,
  stepConnectorClasses,
  StepLabel,
  Stepper,
  styled,
  Tooltip,
  Typography,
} from "@mui/material";
import { useStyles } from "./ProgressStepStyle";
import RegisterIconGrey from "../../assets/icons/steps/pending/register.png";
import InitialAssessmentIconGrey from "../../assets/icons/steps/pending/initialAssessment.png";
import LoadDocsIconGrey from "../../assets/icons/steps/pending/LoadDocs.png";
import DictamenIconGrey from "../../assets/icons/steps/pending/dictamen.png";
import NotificationIconGrey from "../../assets/icons/steps/pending/notification.png";
import ConcludedIconGrey from "../../assets/icons/steps/pending/concluded.png";
import RegisterIconGreen from "../../assets/icons/steps/ready/register.png";
import InitialAssessmentIconGreen from "../../assets/icons/steps/ready/initialAssessment.png";
import LoadDocsIconGreen from "../../assets/icons/steps/ready/LoadDocs.png";
import DictamenIconGreen from "../../assets/icons/steps/ready/dictamen.png";
import NotificationIconGreen from "../../assets/icons/steps/ready/notification.png";
import ConcludedIconGreen from "../../assets/icons/steps/ready/concluded.png";
import { useEffect, useState } from "react";

const CustomConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 25,
    left: "calc(-50% + 35px)",
    right: "calc(50% + 35px)",
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#767676",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#767676",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: "lightgray",
    borderTopWidth: 2,
    // borderRadius: 1,
  },
}));

export const ProgressStep = ({ stepperData, currentStep }) => {
  const localStyles = useStyles();
  const activeStep = stepperData?.find(
    (st) => st.Secuence == currentStep
  )?.Secuence;
  const [currentStepData, setCurrentStepData] = useState({});

  useEffect(() => {
    if (currentStep != null && stepperData != null) {
      const current = stepperData?.find((step) => step.Secuence == currentStep);
      console.log("current::: ", stepperData, current);
      setCurrentStepData(current);
    }
  }, [currentStep]);

  return (
    <Stack className={localStyles.main}>
      <Stepper
        sx={{ width: "100% !important" }}
        activeStep={activeStep}
        connector={<CustomConnector />}
        orientation={"horizontal"}
        alternativeLabel
      >
        {stepperData?.map((step, index) => {
          const isCurrent = index < activeStep;
          return (
            <Tooltip title={step.Name}>
              <Step key={step.Name}>
                <StepLabel
                  icon={
                    <Box
                      sx={{
                        border: `${isCurrent ? 2 : 1}px solid ${
                          isCurrent ? "#767676" : "lightgray"
                        }`,
                        padding: "12px",
                        borderRadius: "100px",
                        width: "50px !important",
                        height: "50px !important",
                        ...(isCurrent && { backgroundColor: "lightgray" }),
                        alignItems: "center",
                        textAlign: "center",
                        fontWeight: 600,
                        color: isCurrent ? "#767676" : "lightgray",
                      }}
                    >
                      {index + 1}
                      {/* <img
                        onContextMenu={(e) => e.preventDefault()}
                        className={localStyles.mainIcon}
                        src={getIconStep(step.Secuence, isCurrent)}
                        alt={`Icono de ${step.Name}`}
                      /> */}
                    </Box>
                  }
                ></StepLabel>
              </Step>
            </Tooltip>
          );
        })}
      </Stepper>
      <Box sx={{ py: 2 }}>
        <Typography
          variant="body1"
          sx={{ pb: 1, fontWeight: 600 }}
        >{`Te encuentras en la etapa ${currentStep} de ${stepperData?.length}:\n${currentStepData?.Name}`}</Typography>
        <Typography variant="body2">{currentStepData?.Description}</Typography>
      </Box>
    </Stack>
  );
};

const getIconStep = (step, active) => {
  switch (step) {
    case 1: //Registro de Solicitud
      return active ? RegisterIconGreen : RegisterIconGrey;
    case 2: //Valoración inicial del reclamo
      return active ? InitialAssessmentIconGreen : InitialAssessmentIconGrey;
    case 3: //Carga de documentos
      return active ? LoadDocsIconGreen : LoadDocsIconGrey;
    case 4: //Proceso de Dictamen
      return active ? DictamenIconGreen : DictamenIconGrey;
    case 5: //Notificación de dictamen
      return active ? NotificationIconGreen : NotificationIconGrey;
    case 6: //Siniestro concluido
      return active ? ConcludedIconGreen : ConcludedIconGrey;
    default:
      return active ? DictamenIconGreen : DictamenIconGrey;
  }
};
